import { useLocation } from '@tanstack/react-router'

import { resolveSurface } from '../surfaces'
import type { Surface } from '../types'

// The help surface for the screen the user is on, from the current path.
export function useCurrentSurface(): Surface {
  const pathname = useLocation({ select: (location) => location.pathname })
  return resolveSurface(pathname)
}
